import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { signInUrlTree } from 'app/core/auth/guards/sign-in-redirect';
import { UserService } from 'app/core/user/user.service';
import { hasRole } from 'app/core/user/user-role.utils';
import { of } from 'rxjs';

/**
 * Guard de rol admin.
 *
 * Se asume que corre después del AuthGuard (el usuario ya está autenticado y
 * cargado), así que lee `UserService.currentUser` directo. Si no hay usuario
 * (la sesión se cerró entretanto) va al sign-in, como un no autenticado; si
 * no tiene el rol 'admin', a la raíz (issue #82).
 *
 * Usa `hasRole` (y no `roles.includes`) para que una sesión abierta durante
 * el deploy del issue #13, cuyo JWT todavía dice `super_admin`, no quede
 * afuera del panel hasta re-loguearse.
 */
export const AdminGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const user = inject(UserService).currentUser;

    if (!user) {
        return of(signInUrlTree(router, state.url));
    }

    return of(hasRole(user, 'admin') ? true : router.parseUrl('/'));
};
